module.exports = __webpack_public_path__ + "static/media/tablet5.34779dbd.png";